export default {
  exceptionType: '异常类型',
  emailEvent: '邮件事件',
  emailReceiver: '邮件接收者',
  emailSendStatus: '邮件发送状态',
  emailEventStatus: '邮件事件状态',
  email: '邮箱',
  systemName: '系统名称',
  lastSendTime: '上次发送时间',
  addOrEdit: '添加/删除接收者',
  disabledEmailDataTip: '您确定要禁用此邮件事件吗？',
  enableEmailDataTip: '您确定要启用此邮件事件吗？',
  error_3001: '请输入正确的用户邮件地址。',
  error_3002: '此接收者已存在于系统中。',
  showOpt: '显示操作列'
}
